import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';

import { addLocaleToPathIfNeeded } from '../../utils';

export class LocalizedBreadcrumbsItem extends React.Component {
    render() {
        const { disabled } = this.props;

        return (
            <BreadcrumbsItem to={addLocaleToPathIfNeeded(this.props)} disabled={disabled}>
                {this.props.children}
            </BreadcrumbsItem>
        );
    }
}
const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    };
};

LocalizedBreadcrumbsItem.propTypes = {
    disabled: PropTypes.bool
};

export default connect(mapStateToProps)(LocalizedBreadcrumbsItem);



// WEBPACK FOOTER //
// ./src/components/breadcrumb/LocalizedBreadcrumbsItem.js